import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=54f19ce8&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=js"
export * from "./resetPwd.vue?vue&type=script&lang=js"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=54f19ce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f19ce8",
  null
  
)

export default component.exports